// extracted by mini-css-extract-plugin
export default {"container":"listSectionItem_container__Vp5kT","light":"listSectionItem_light__oboyd"};